export interface TaskBrief {
  id: string;
  category: string;
  summary: string;
  location: string;
  instruction: string;
  proof: string;
  payout: string;
  medianTime: string;
  availableTaskers: string;
}

export const taskBriefs: TaskBrief[] = [
  {
    id: 'payments',
    category: 'Payments testing',
    summary: 'Real cards, real rails, real receipts.',
    location: 'Colombia',
    instruction:
      'Test a payment on our e-commerce platform using a local Colombian debit card. Complete the $1 test transaction and submit proof. We reimburse you plus pay $8.',
    proof: 'screenshot_required',
    payout: '$8 + $1 reimbursed',
    medianTime: '42 min',
    availableTaskers: '1,240',
  },
  {
    id: 'concierge',
    category: 'Concierge',
    summary: 'Bookings and errands done in person.',
    location: 'Istanbul, Türkiye',
    instruction:
      'Book a standard room at the listed hotel for next Friday, confirm breakfast is included, and photograph the lobby on check-in day.',
    proof: 'photo_required',
    payout: '$16',
    medianTime: '3 hr',
    availableTaskers: '860',
  },
  {
    id: 'support',
    category: 'Customer support',
    summary: 'Mystery-shop your help desk, locally.',
    location: 'Jakarta, Indonesia',
    instruction:
      'Call our Bahasa support line from a local number, ask about a refund, and log total hold time plus whether the agent resolved it.',
    proof: 'call_log_required',
    payout: '$6',
    medianTime: '25 min',
    availableTaskers: '2,110',
  },
  {
    id: 'companion',
    category: 'Companion',
    summary: 'A trusted local, on the ground for you.',
    location: 'Lisbon, Portugal',
    instruction:
      'Meet our arriving employee at the airport, help them buy a local SIM card, and ride with them to the office.',
    proof: 'check_in_required',
    payout: '$20',
    medianTime: '2 hr',
    availableTaskers: '430',
  },
  {
    id: 'gaming',
    category: 'Gaming',
    summary: 'Latency and store checks from real ISPs.',
    location: 'Seoul, South Korea',
    instruction:
      'Play three ranked matches on a home KT connection and record ping, packet loss, and the in-game store price for the season pass.',
    proof: 'video_required',
    payout: '$10',
    medianTime: '1 hr',
    availableTaskers: '690',
  },
  {
    id: 'logistics',
    category: 'Logistics',
    summary: 'Track the last mile as a real customer.',
    location: 'Nairobi, Kenya',
    instruction:
      'Order the listed item for delivery, time each status update, and photograph the package condition at the door.',
    proof: 'photo_required',
    payout: '$12',
    medianTime: '4 hr',
    availableTaskers: '980',
  },
];
